import store from '../store/store'
export default function pre_auth({ next, router }) {
  if (store.getters["auth/getUser"] != null && store.getters["extended_auth/get_extended_session_token"] != null) {
    return router.replace("/");
  }
  return next();
}